import React, { useState } from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post('https://formspree.io/f/xbjnyjgz', formData);
      setShowSuccessMessage(true);
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      alert('Error sending message. Please try again later.');
    }
  };

  const buttonTheme = createTheme({
    palette: {
      mode: 'light',
    },
  });

  return (
    <div className= 'contact'>
      <h2>Contact Me</h2>
      <form onSubmit={handleSubmit} >
        <div className='formfield'>
          <TextField
            label="Name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            required
          />
        </div>
        <div className='formfield'>
          <TextField
            label="Email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            required
          />
        </div>
        <div className='formfield'>
          <TextField
            label="Message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            multiline
            rows={4}
            variant="outlined"
            fullWidth
            required
          />
        </div>
        {showSuccessMessage && (
          <div>
            Thank you for your submission, your message was sent successfully!
          </div>
        )}
        <ThemeProvider theme={buttonTheme}>
          <Button
            variant='contained'
            type='submit'
            size='large'
            className='customButton'
          >
            Submit
          </Button>
        </ThemeProvider>
      </form>
    </div>
  );
};

export default Contact;
